import { proxy, ref } from 'valtio'
import { DateTime } from 'luxon'
import { IPoint } from '../interfaces/types.ts'

export interface MovieStateType {
    playbackSpeed: 'fast' | 'slow'
    playIndex: number
    frameMarkers: any[]
    indexTime: DateTime
    intervalTimer: any
    locations: IPoint[]
    animateLat: number
    animateLng: number
    deltaLat: number
    deltaLng: number
    step: number
    curStep: number
    distance: number
    speed: number
    rotation: number
    startDate: DateTime
    endDate: DateTime
    playForward: boolean
    playReverse: boolean
    playbackView: 'close' | 'far'
}

export const movieState = proxy<MovieStateType>({
    playbackSpeed: 'fast',
    playIndex: 0,
    frameMarkers: [],
    indexTime: ref(DateTime.now()) as unknown as DateTime,
    intervalTimer: 0,
    locations: [],
    animateLat: 0,
    animateLng: 0,
    deltaLat: 0,
    deltaLng: 0,
    step: 0,
    curStep: 0,
    distance: 0,
    speed: 100,
    rotation: 0,
    startDate: ref(DateTime.now()) as unknown as DateTime,
    endDate: ref(DateTime.now()) as unknown as DateTime,
    playForward: false,
    playReverse: false,
    playbackView: 'close',
})

// --- Action functions for multi-field mutations ---

export function setAnimationState(animationState: {
    animateLat: number
    animateLng: number
    deltaLat: number
    deltaLng: number
    step: number
    curStep: number
    distance: number
    speed?: number
    rotation: number
}) {
    Object.assign(movieState, animationState)
}

export function setFrameDates(startDate: DateTime, endDate: DateTime) {
    movieState.startDate = ref(startDate) as unknown as DateTime
    movieState.endDate = ref(endDate) as unknown as DateTime
}

export function setAnimatePosition(lat: number, lng: number) {
    movieState.animateLat = lat
    movieState.animateLng = lng
}

export function resetMovie() {
    movieState.playIndex = 0
    movieState.intervalTimer = 0
    movieState.playbackSpeed = 'fast'
}

export default movieState
